import { mergeAll } from 'lodash/fp'

import assignedActions from './actions/assigned.actions'
import joinActions from './actions/join.actions'

export default mergeAll([assignedActions, joinActions])
